export enum Team {
  Neutral,
  Friendly,
  Enemy,
}
